export const numberFormat = (amount) => {
    return new Intl.NumberFormat("en-us", { minimumFractionDigits: 2 }).format(amount);
};
export const wholeNumber = (amount) => {
    return `${amount}`.padStart(2, "0");
};
//# sourceMappingURL=number-format.js.map